import { get, post, del } from "./ApiService";

const ASSIGNEES_ENDPOINT = "/bug_assignees";

// Bir işe atanmış kullanıcıları getirir
export const getAssignees = async (bugId) => {
  const response = await get(ASSIGNEES_ENDPOINT, { bug_id: bugId });
  return Array.isArray(response?.assignees) ? response.assignees : [];
};

// İşe kullanıcı atar (assignedBy verilmezse API token'dan çözer)
export const addAssignee = async ({ bugId, userId, assignedBy } = {}) => {
  const response = await post(ASSIGNEES_ENDPOINT, {
    bug_id: bugId,
    user_id: userId,
    assigned_by: assignedBy,
  });

  if (response?.status === "error") {
    throw new Error(response?.message || "Kullanıcı işe atanamadı.");
  }

  return response;
};

// İşten atamayı kaldırır
export const removeAssignee = async ({ bugId, userId } = {}) => {
  const response = await del(ASSIGNEES_ENDPOINT, {
    bug_id: bugId,
    user_id: userId,
  });

  if (response?.status === "error") {
    throw new Error(response?.message || "Atama kaldırılamadı.");
  }

  return response;
};
